<template>
  <el-dialog
    v-drag
    :title="`代理账单详情-${rowData.supplierName}`"
    :visible.sync="dialogFormVisible"
    width="1400px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    :before-close="cancel"
  >
    <div class="content">
      <BaseTable
        :height="600"
        :tableData="tableData"
        :isPager="false"
        :loading="loading"
        element-loading-text="系统处理中，请稍等..."
      >
      </BaseTable><p class="tips">
        <span>
          共选择
          <span style="color: #fe453d">{{ tableData.columns.length }}</span>
          条数据
        </span>
        <span>
          合计：
          <span style="color: #fe453d">{{ sumAmount }}</span>
        </span>
      </p>
    </div>
  </el-dialog>
</template>
<script>
import { getPayablePages1 } from '@/api/fee'
const BaseTable = () => import('@/components/table/BaseTable')
import Decimal from 'decimal.js'

export default {
    components: { BaseTable },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      tableData: {
        fileds: [
          {
            filed: 'companyName',
            label: '客户',
            width: '220',
            isSort: true,
            align: 'left'
          },
          {
            filed: 'mblNo',
            label: '提单号',
            width: '220',
            isSort: true,
            align: 'left'
          },
          {
            filed: 'blNo',
            label: '分单号',
            width: '220',
            isSort: true,
            align: 'left'
          },
          {
            filed: 'supplieName',
            label: '供应商',
            width: '90'
          },
          {
            filed: 'containerNumber',
            label: '柜号',
            width: '220',
            align: 'left'
          },
          {
            filed: 'qty',
            label: '数量',
            width: '80',
            isSort: true
          },
          {
            filed: 'unitPrice',
            label: '单价',
            width: '100',
            isSort: true
          },
          {
            filed: 'totalAmount',
            label: '金额',
            width: '100',
            isSort: true
          },
          {
            filed: 'feeName',
            label: '费用项',
            width: '220',
            isSort: true,
            align: 'left'
          },
          {
            filed: 'directCode',
            label: '直送仓库',
            width: '150'
          },
          {
            filed: 'isHold',
            label: '是否查验',
            width: '150',
            formatter: row => {
              return row.isHold ? '是' : '否'
            }
          },
          {
            filed: 'mblStatus',
            label: '提单状态',
            width: '150',
            formatter: (row) => {
              const obj = {
                0: '未完结',
                1: '未完结',
                3: '已完结',
                4: '已完结'
              }
              return obj[row.mblStatus] || '未完结'
            }
          },
          {
            filed: 'picPickUpDate',
            label: '提柜时间',
            width: '160',
            formatter: (row) =>
              row.picPickUpDate
                ? row.picPickUpDate.slice(0, row.picPickUpDate.length - 9)
                : ''
          },
          {
            filed: 'firstDepartureDate',
            label: '出库时间',
            width: '160',
            formatter: (row) =>
              row.firstDepartureDate
                ? row.firstDepartureDate.slice(0, row.firstDepartureDate.length - 9)
                : ''
          },
          {
            filed: 'supplierInvoiceDate',
            label: '账单日期',
            width: '180',
            isSort: true
          },
          {
            filed: 'remark',
            label: '备注',
            width: ''
          }
        ],
        columns: [],
        total: 0
      },
      sortObj: {
        filed: 'invoiceDate',
        order: 'desc'
      },
      loading: false
    }
  },
  computed: {
    sumAmount() {
      return this.tableData.columns.reduce((acc, cur) => {
        return acc + new Decimal(cur.totalAmount).toNumber()
      }, 0)
    }
  },
  watch: {
    dialogFormVisible(val) {
      if (val) {
        this.getList()
      }
    }
  },
  created() {
    // this.getList()
  },
  methods: {
    cancel() {
      this.$emit('cancel')
      this.tableData.columns = []
    },
    async getList() {
      try {
        this.loading = true
        const res = await getPayablePages1({
            pageIndex: 1,
            pageSize: 10000,
            queryParam: {
                supplierInvoiceId: this.rowData.id
            }
        })
        if (res.success) {
          this.tableData.columns = res.data.list
        } else {
          this.$message.error(res.errorMessage)
        }
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },
    sortChange(sortObj) {
      this.sortObj = sortObj
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 100%;

  .tips {
    height: 20px;
    font-size: 14px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    color: #77879e;
    line-height: 20px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
}
.footers {
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
/deep/.el-form--label-top .el-form-item__label {
  padding: 0;
}
</style>
